import Swiper from "swiper";
import {Autoplay, FreeMode} from "swiper/modules";

export function initProjectPreview() {
    for (const preview of document.querySelectorAll('.projects.projectsSwiper.swiper')) {
        const instance = preview?.swiper;

        if (instance) {
            instance.destroy();
        }

        try {
            const wrapper = preview.querySelector('.swiper-wrapper');
            const slides = wrapper?.querySelectorAll('.swiper-slide');

            if (!slides || slides.length < 2) {
                continue;
            }

            Swiper.use([Autoplay, FreeMode]);

            new Swiper(preview, {
                loop: true,
                freeMode: {
                    enabled: true,
                    momentum: true,
                    momentumRatio: 0.5,
                },
                grabCursor: true,
                speed: 5000,
                spaceBetween: 10,
                slidesPerView: 'auto',
                autoplay: {
                    delay: 0,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                },
                breakpoints: {
                    768: {
                        spaceBetween: 20,
                    }
                }
            });
        } catch (error) {
            console.error('Error initializing Projects Swiper:', error);
        }
    }
}